module.exports = __webpack_public_path__ + "static/media/Hazmat Guy.e2ad71e8.jpg";